import { Skeleton } from 'antd';
import styled from 'styled-components';
export const CustomSkeleton = styled(Skeleton).withConfig({
  displayName: "CreatorProfilestyle__CustomSkeleton",
  componentId: "sc-jj3yfq-0"
})([".ant-skeleton-title{", "}@media (max-width:", "){.ant-skeleton-avatar{", "}.ant-skeleton-title{", "}.ant-skeleton-paragraph{", "}}"], {
  "height": "1.25rem !important",
  "width": "10rem !important"
}, ({
  theme
}) => theme.breakpoint.md, {
  "height": "1.75rem !important",
  "width": "1.75rem !important"
}, {
  "marginTop": "0.25rem !important",
  "height": "1.25rem !important",
  "width": "7rem !important"
}, {
  "display": "none"
});